import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AcessoExternoRouterService } from './acesso-externo.routing.service';
import { AcessoExternoComponent } from './index.component';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([ 
    { path: 'acesso-externo', component: AcessoExternoComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [AcessoExternoRouterService]
})
export class AcessoExternoRoutingModule { }
